import { createAction } from 'redux-actions';

export const setSettings = createAction('SET_SETTINGS');


